import { render, staticRenderFns } from "./CsDetail.vue?vue&type=template&id=593728d5&scoped=true&"
import script from "./CsDetail.vue?vue&type=script&lang=js&"
export * from "./CsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CsDetail.vue?vue&type=style&index=0&id=593728d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593728d5",
  null
  
)

export default component.exports